import React from 'react';
import {Link} from 'react-router';
import {Input, DatePicker} from 'components/tt-forms/common';
import {
  DropDownMulipleUse
} from 'components/tt-forms';
import moment from 'moment';

class RowItemChiTietThanhVienCuocThanhTra  extends React.Component {

  constructor(props, context) {
    super(props, context)
    this.state = {
      hoVaTen: this.props.item.hoVaTen,
      ngaySinh: this.props.item.ngaySinh ? new Date(this.props.item.ngaySinh) : '',
      donVi: this.props.item.donVi,
      chucVu: this.props.item.chucVu,
      vaiTroThanhVienDoan: this.props.item.vaiTroThanhVienDoan ? this.props.item.vaiTroThanhVienDoan : '',
      thanhVienDoanId: this.props.item.thanhVienDoanId,
      dataVaiTroThanhVienDoan: this.props.dataVaiTroThanhVienDoan
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      hoVaTen: nextProps.item.hoVaTen,
      ngaySinh: nextProps.item.ngaySinh ? new Date(nextProps.item.ngaySinh) : '',
      donVi: nextProps.item.donVi,
      chucVu: nextProps.item.chucVu,
      vaiTroThanhVienDoan: nextProps.item.vaiTroThanhVienDoan ? nextProps.item.vaiTroThanhVienDoan : '',
      thanhVienDoanId: nextProps.item.thanhVienDoanId,
      dataVaiTroThanhVienDoan: nextProps.dataVaiTroThanhVienDoan
    })
  }

  onChange(name, e) {
    this.setState({
      [name]: e.target.value
    }, () => {
      this.pushData();
    })
  }

  onItemRemove() {
    this.props.onItemRemove(this.props.count - 1)
  }

  handleChangeDate(name, e) {
    if (e && e._d) {
      this.setState({
        [name]: e._d
      }, () => {
        this.pushData();
      })
    } else {
      this.setState({
        [name]: e
      }, () => {
        this.pushData();
      })
    }
  }

  pushData() {
    let data = {
      hoVaTen: this.state.hoVaTen ? this.state.hoVaTen : '',
      ngaySinh: this.state.ngaySinh ? moment(this.state.ngaySinh).toISOString() : '',
      donVi: this.state.donVi ? this.state.donVi : '',
      chucVu: this.state.chucVu ? this.state.chucVu : '',
      vaiTroThanhVienDoan: this.state.vaiTroThanhVienDoan ? this.state.vaiTroThanhVienDoan : '',
    }
    if (this.state.thanhVienDoanId) {
      data.thanhVienDoanId = Number(this.state.thanhVienDoanId);
    }
    this.props.onItemChange(data, this.props.count - 1)
  }

  render() {
    return (
      <tr>
        <td>{this.props.count}</td>
        <td><Input triggeOnBlur={true} className='col-100 mb0-18' value={this.state.hoVaTen} onChange={this.onChange.bind(this, 'hoVaTen')}/></td>
        <td><DatePicker className='col-100 mb0-18' value={this.state.ngaySinh} onChange={this.handleChangeDate.bind(this, 'ngaySinh')}/></td>
        <td><Input triggeOnBlur={true} className='col-100 mb0-18' value={this.state.donVi} onChange={this.onChange.bind(this, 'donVi')}/></td>
        <td><Input triggeOnBlur={true} className='col-100 mb0-18' value={this.state.chucVu} onChange={this.onChange.bind(this, 'chucVu')}/></td>
        <td><DropDownMulipleUse label='' className='col-100 mb0-18' data={this.state.dataVaiTroThanhVienDoan} selectedValue={this.state.vaiTroThanhVienDoan} onChange={this.onChange.bind(this, 'vaiTroThanhVienDoan')} valueName='ten' keyName='giaTri'/></td>
        <td className="wrap-link-todo link-attach">
          <Link className="itt-delete" onClick={this.onItemRemove.bind(this)}>Xóa</Link>
        </td>
      </tr>
    );
  }
}

RowItemChiTietThanhVienCuocThanhTra.defaultProps = {
  item: {
    hoVaTen: '',
    ngaySinh: '',
    donVi: '',
    chucVu: '',
    vaiTroThanhVienDoan: '',
    id: '',
    dataVaiTroThanhVienDoan: []
  }
}

export default RowItemChiTietThanhVienCuocThanhTra;


// WEBPACK FOOTER //
// ./src/components/modules/thanh-tra/datatable/RowItemChiTietThanhVienCuocThanhTra.jsx